export function triproutesPublicationStatus(publication, dirty = false) {
  if (!publication) return { label: "Статус недоступен", className: "state-partial" };
  if (publication.state === "unsupported") return { label: "Не перенесён в Harness", className: "" };
  if (publication.state === "suspended") return { label: "Приостановлен", className: "state-partial" };
  if (publication.state === "active") {
    return dirty || !publication.draftPublished
      ? { label: "Есть неопубликованные изменения", className: "state-partial" }
      : { label: "Опубликован", className: "state-completed" };
  }
  if (publication.state === "inactive") return { label: "Не активен", className: "" };
  return { label: "Черновик не опубликован", className: "state-partial" };
}
